/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/21/17
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Navbar } from 'reactstrap';
import SP3Logo from 'components/support/logos/SP3Logo';
import {
  header,
  productAttribution,
  productName,
} from './Header.module.scss';

const Header = () => (
  <Navbar className={header} fixed="top">
    <span>{<SP3Logo />}</span>
    <span className={productName}> Demo </span>
    <span className={productAttribution}> by Haselton Baker Risk Group</span>
  </Navbar>
);

export default Header;



// WEBPACK FOOTER //
// ./js/components/support/layout/Header/index.jsx